import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router';

import { useAppSelector } from 'src/app/store/hooks';
import Switch from 'src/common/primitives/Switch';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

import { GeolocationSearch } from './geolocations/management/GeolocationSearch';
import {
  setShowArchivedGeolocations,
  setShowGeolocationModal,
  setShowTagsModal,
  setTagSearchTerm,
} from './setting.slice';

export function SettingsRouteActions() {
  return (
    <Routes>
      <Route index element={<></>} />
      <Route path="tags" element={<TagRouteActions />} />
      <Route path="geolocations" element={<GeolocationRouteActions />} />
    </Routes>
  );
}

export function TagRouteActions() {
  const dispatch = useDispatch();
  const tagSearchTerm = useAppSelector((state) => state.setting.tagSearchTerm);

  const { inputValue, handleInputChange } = useDebouncedSearch(
    setTagSearchTerm,
    tagSearchTerm
  );

  return (
    <div className="flex items-center gap-4">
      <SearchTypeahead
        dataTestId="tags-search"
        onChange={handleInputChange}
        placeholder="Search tags"
        value={inputValue}
      />
      <Button
        onClick={() => dispatch(setShowTagsModal(true))}
        variant="primary"
      >
        Add a Tag
      </Button>
    </div>
  );
}

export function GeolocationRouteActions() {
  const dispatch = useDispatch();
  const { showArchivedGeolocations } = useAppSelector((state) => state.setting);

  return (
    <>
      <div className="flex text-sm" style={{ height: '80%' }}>
        <label className="flex items-center gap-2">
          <Switch
            label="Show archived geolocations"
            inputProps={{
              value: showArchivedGeolocations,
              onChange: (nextValue: boolean) => {
                dispatch(setShowArchivedGeolocations(nextValue));
              },
            }}
          />
          Include archived
        </label>
      </div>
      <GeolocationSearch />
      <Button
        onClick={() => dispatch(setShowGeolocationModal(true))}
        variant="primary"
      >
        Add a Geolocation
      </Button>
    </>
  );
}
